import { IListItem } from '@andromeda/calvera-prototype-multi-retailer-cart-data-access-store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
})

export default class BasicListItem extends Vue {
    @Prop({ required: true }) listItem!: IListItem;
    @Prop() displayStacked!: boolean;

    isActive = false;

    get active() {
        return this.isActive;
    }

    onHover(): void {
        if (!this.displayStacked) {
            this.isActive = true;
        }
    }

    onLeave(): void {
        if (!this.displayStacked) {
            this.isActive = false;
        }
    }
}
